import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { convertToRaw, RichUtils, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import PropTypes from 'prop-types';
import { blockType } from '../../../../../../../../types';
import { DropdownIndicator, generateSelectStyles } from '../../../../../../../../common/generateSelectStyling';
import * as columnItemActions from '../../../../../../../../actions/columnItem';

const headerOptions = [
    { value: 'unstyled', label: 'Normal', fontSize: 16, lineHeight: 1.5 },
    { value: 'header-one', label: 'Header 1', fontSize: 36, lineHeight: 2 },
    { value: 'header-two', label: 'Header 2', fontSize: 24, lineHeight: 1.5 },
    { value: 'header-three', label: 'Header 3', fontSize: 18, lineHeight: 1.17 },
];

const handleDispatch = (blockTypeValue, { editorState, content, dispatch, blockIndex, columnIdx, elmIdx }) => {
    const newState = RichUtils.toggleBlockType(editorState, blockTypeValue);
    const headerOption = headerOptions.find((option) => option.value === blockTypeValue);
    const { fontSize, lineHeight } = headerOption;

    const newMarkupString = draftToHtml(convertToRaw(newState.getCurrentContent()));
    const newContent = {
        ...content,
        fontSize: `${fontSize}px`,
        lineHeight: `${fontSize * lineHeight}px`,
        textMarkupValue: newMarkupString,
    };
    dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
};

class Headers extends Component {
    onChange = ({ value }) => {
        const { dispatch, canvasBlocks, selectedElements, editorState } = this.props;
        const elmIdx = Object.keys(selectedElements)[0];
        const { blockIndex, columnIdx } = selectedElements[elmIdx];
        const column = canvasBlocks
            .filter((block) => block.index === blockIndex)[0]
            .content.columns.filter((c) => c.columnIdx === columnIdx)[0];
        const { content } = column.columnItems.filter((el) => el.elmIdx === elmIdx)[0];
        const dispatchData = {
            editorState,
            content,
            dispatch,
            blockIndex,
            columnIdx,
            elmIdx,
        };
        handleDispatch(value, dispatchData);
    };

    render() {
        const { editorState } = this.props;
        const blockTypeString = RichUtils.getCurrentBlockType(editorState);
        const { label } = headerOptions.find((option) => option.value === blockTypeString) || headerOptions[0];
        return (
            <Select
                className="current-text-element-type"
                style={{ borderLeft: '1px solid #D9DAD', width: 99 }}
                value={blockTypeString}
                placeholder={label}
                options={headerOptions}
                components={{ DropdownIndicator }}
                styles={generateSelectStyles({ sideBorders: true, width: 110, height: 28, hideBorder: true })}
                onChange={this.onChange}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements.local,
});

Headers.propTypes = {
    dispatch: PropTypes.func.isRequired,
    config: PropTypes.shape({
        component: PropTypes.func.isRequired,
        inDropdown: PropTypes.bool,
        options: PropTypes.arrayOf(PropTypes.string).isRequired,
        title: PropTypes.instanceOf(EditorState),
    }).isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    selectedElements: PropTypes.object.isRequired,
    editorState: PropTypes.instanceOf(EditorState).isRequired,
};

export default connect(mapStateToProps)(Headers);
